<template>
  <div class="detail-view" ref="base" @click="onBaseClick">
    <div v-if="isShowInner" class="detail-view__inner">

      <div v-if="itemData.itemType === 2" class="inner__video">
        <video-player-core
          :video-src="itemData.videoData.url"
          :poster="itemData.videoData.thumbnail"
          :duration="itemData.videoData.duration"
          :send-info="sendVideoInfo"
        />
        <div class="inner__video__info">
          <h2 class="detail-view__videoTitle">{{ !!itemData ? itemData.name : ''}}</h2>
          <div class="menu-tags">
            <span class="menu-tags__tag-icon"><img src="/static/img/icons/ic_tag.svg" class="menu-tags__img"></span>
            <tag-list class="menu-tags__tag-list" :tag-list="tags" :link-enable="true" :is-movie-item="isMovieItem"/>
          </div>
          <fav-button
            class="inner__video__fav"
            @fav-click="onFavClick"
            :fav-status="favStatus"
            :fav-num="favNum"
            />
        </div>
      </div>

      <div v-else class="inner__text">
        <div class="detail-view__head">
          <h2 class="detail-view__title">{{ !!itemData ? itemData.name : ''}}</h2>
          <div class="menu-tags">
            <span class="menu-tags__tag-icon"><img src="/static/img/icons/ic_tag.svg" class="menu-tags__img"></span>
            <tag-list class="menu-tags__tag-list" :tag-list="tags" :link-enable="true" />
          </div>
        </div>
        <div class="detail-view__description"
          v-html="!!itemData ? !!itemData.result ? itemData.result.text : '' : ''"
        ></div>
        <div class="detail-footer">
          <div class="inner">
            <fav-button
              @fav-click="onFavClick"
              :fav-status="favStatus"
              :fav-num="favNum"
            />
            <span class="has-partner-info" v-if="hasPartner" @click.stop="onChangePartnerClick">
              相手を変更して占う
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.98293 19.3882C8.64211 19.0568 8.64211 18.5196 8.98293 18.1883L15.3476 12.0004L8.98293 5.81244C8.64211 5.48109 8.64211 4.94386 8.98293 4.61251C9.32375 4.28115 9.87633 4.28115 10.2172 4.61251L17.199 11.4004C17.5398 11.7317 17.5398 12.269 17.199 12.6003L10.2172 19.3882C9.87633 19.7196 9.32375 19.7196 8.98293 19.3882Z" fill="#656D78"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {PLAYLIST_TYPE, MENU_ITEM_TYPE} from '@/CONSTS/MENUS'
import TagList from '@/utvStore/components/partials/TagList'
import FixedBackground from '@/utvStore/components/partials/FixedBackground'
import FavButton from '@/utvStore/components/partials/FavButton'
import VideoPlayerCore from '@/utvStore/components/VideoPlayer/VideoPlayerCore'
import {mapState} from 'vuex'
import * as type from "@/utvStore/store/mutation-types";

export default {
  name: "DetailView",
  components: {FavButton, FixedBackground, TagList, VideoPlayerCore},
  data() {
    return {
      base: null,
      scrPos: 0,
      allHeight: 0,
      hasPartner: false,
      favNum: 0,
      favStatus: false,
      isShowInner:false,
      isMovieItem: false
    }
  },
  props: {
    trigger: {
      type: Boolean,
      default() {
        return false
      }
    },
    closeTrigger: {
      type: Boolean,
      default() {
        return false
      }
    },
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    trigger(val) {
      if (val) {
        this.isShowInner = true
        window.scrollTo(0, 0)
        this.hasPartner = this.isRequirePartner()
        this.base.classList.add('enabled')
        this.base.addEventListener('transitionend', this.onOpenComplete)
        this.setItemData()
        setTimeout(() => this.base.classList.add('open'), 100)
      }
    },
    itemData: {
      handler(val){
        if(this.trigger) {
          this.setItemData()
        }
      },
      deep: true
    },
    closeTrigger(val) {
      if (val && this.trigger) { //valがtrueでtriggerがtrueのときのみ発動
        this.isShowInner = false
        this.closeDetail()
      }
    }
  },
  computed: {
    ...mapState({
      accessToken: states => states.auth.accessToken,
      subscriptVideoData: states => states.item.subscrItems
    }),
    tags() {
      if (!!this.itemData && !!this.itemData.tags) {
        return this.itemData.tags
      }
      return
    },
    sendVideoInfo(){
      return {
        menuId: this.itemData.id,
        accToken: this.accessToken
      }
    }
  },
  mounted() {
    this.base = this.$refs.base

    // fixed-background 用
    window.onresize = this.setAllHeight
    window.onscroll = this.onBaseScroll
    this.$nextTick(()=>this.setAllHeight())
  },
  methods: {
    setItemData() {
      this.favNum = this.itemData.localFavNum
      this.favStatus = this.itemData.localFavStat
      this.isMovieItem = +this.itemData.itemType === MENU_ITEM_TYPE.movie
    },
    onBaseClick() {
      // this.closeDetail()
    },
    onChangePartnerClick(){
      this.$emit('change-partner-click', this.itemData.id)
    },
    onFavClick(stat) {
      //ここで自身のfavStatusとfavNumを設定
      this.$store.dispatch(type.SET_ITEM_FAVORITE, {
        menuId: this.itemData.id,
        stat: !this.favStatus,
        userId: this.userProfile.id,
        accToken: this.accessToken
      })
    },
    closeDetail() {
      this.base.classList.remove('open')
      this.base.addEventListener('transitionend', this.onCloseComplete)
    },
    onOpenComplete() {
      this.base.removeEventListener('transitionend', this.onOpenComplete)
    },
    onCloseComplete() {
      this.base.removeEventListener('transitionend', this.onCloseComplete)
      this.base.classList.remove('enabled')
      setTimeout(() => this.$emit('close-complete'), 0)
    },
    // fixed-background 用
    setAllHeight(){
      this.allHeight = this.$el.clientHeight
    },
    // fixed-background 用
    onBaseScroll(e) {
      this.scrPos = window.pageYOffset
    },
    isRequirePartner(){
      if(!!this.itemData.required && this.itemData.required.length > 0){
        return this.itemData.required.some(item =>{
          return Object.keys(item)[0].includes('target')
        })
      }else{
        return false
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.detail-view {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 100%;
  transition: transform 200ms ease-out 0s;
  background: $col_verylite_gray;
  display: none;
  padding-top: 44px;
  padding-bottom: 50px;
  @include mq('w580') {
    background: $col_verylite_gray;
    padding-bottom: 0;
  }

  &.enabled {
    display: block;
  }

  &.open {
    transform: translate3d(-100%, 0, 0);
  }

  &__inner {
    width: 100%;
    max-width: 580px;
    max-height: 100%;
    margin: 0 auto;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: $col_white;
    background-image: url('/static/img/common/background/bg_def_moya1.jpg'),
            url('/static/img/common/background/bg_def_moya2.jpg');
    background-size: 375px auto, 375px auto;
    background-position: 0 0, 100% calc(100% - 20px);
    background-repeat: no-repeat, no-repeat;
    border-bottom: 1px solid $col_temp_gray3;
    @include mq('w580') {
      border-bottom: none;
      height: 100%;
    }
    .inner__text{
      padding: 30px 40px 10px;
    }
    .inner__video{
      padding: 0;

      &__info{
        padding: 20px;
      }
      &__fav{
        margin-top: 8px;
      }
    }
  }
  &__head {
    margin: 0 -10px 33px;
    padding: 0 10px 27px;
    border-bottom: 1px solid $col_temp_gray3;
  }
  &__title{
      margin: 0 0 7px;
      font-size: 20px;
      line-height: 30px;
      color: $col_base_black;
  }
  &__videoTitle{
    margin: 0 0 7px;
    font-size: 16px;
    line-height: 20px;
    color: $col_base_black;
  }
  &__description {
    font-size: 16px;
    line-height: 27px;
    margin-bottom: 30px;
    /deep/ .tarot-img {
      filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.25));
      display: block;
      width: 60%;
      max-width: 200px;
      margin: 9% auto !important;
    }
  }
  .detail-footer{
    border-top: 1px solid $col_temp_gray3;
    padding: 18px 10px;
    margin: 0 -10px;

    .inner{
      display: flex;
      align-items: center;
      justify-content: space-between;
      /deep/ .fav-btn-base {
        .fav-num {
          padding-top: 5px;
        }
      }
    }
    .has-partner-info{
      font-size: 13px;
      font-weight: bold;
      color: $col_temp_gray6;
      display: flex;
      align-items: center;
    }
  }
}

.menu-tags {
  display: block;
  padding-left: 18px;
  position: relative;
  &__tag-icon {
    display: inline-block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 13px;
  }
  &__img {
    display: block;
    width: 100%;
  }

  &__tag-list {
    display: inline-block;
    line-height: 1.3;
    color: $col_normal_font;

    .menu-tags & /deep/ > li {
      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/DetailView.vue